export default {
  portal: {
    // Minutes
    iddleTime: 20,
    // Seconds
    iddleCountDown: 60,
    timezone: 'America/Chicago',
  },
};
